module.exports = __webpack_public_path__ + "39df966a27d60eebd7d2af7030549727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key1.png
// module id = 236
// module chunks = 1